// src/core/inventarios/infrastructure/supabase/MovimientoInventarioRepository.js

import { supabase } from '../../../infra_/supabase/supabaseClient.js';
import { MovimientoInventarioRepositoryInterface } from '../../domain/repositories/MovimientoInventarioRepository.interface.js';

export class MovimientoInventarioRepository extends MovimientoInventarioRepositoryInterface {
  async insertarMovimientoInventario(movimiento) {
    console.log("[RepositoryDriven][Repository] Insertando movimiento:", movimiento);

    const { data, error } = await supabase
      .from("movimientos_inventario")
      .insert([movimiento])
      .select()
      .single();

    if (error) {
      console.error("[RepositoryDriven][Repository] Error al insertar movimiento:", error);
      throw error;
    }

    console.log("[RepositoryDriven][Repository] Movimiento insertado:", data);
    return data;
  }

  async obtenerMovimientoInventario(filtros = {}) {
    console.log("[RepositoryDriven][Repository] Obteniendo movimientos con filtros:", filtros);

    let query = supabase
      .from("vista_movimientos_inventario_periodo")
      .select("*")
       .order("movimiento_id", { ascending: false }
      );


    if (filtros.tipo) query = query.eq("tipo_movimiento", filtros.tipo);
    if (filtros.origen) query = query.eq("origen", filtros.origen);
    if (filtros.fechaInicio) query = query.gte("fecha_creacion", filtros.fechaInicio);
    if (filtros.fechaFin) query = query.lte("fecha_creacion", filtros.fechaFin);

    const { data, error } = await query;

    if (error) {
      console.error("[RepositoryDriven][Repository] Error al obtener movimientos:", error);
      throw error;
    }

    console.log("[RepositoryDriven][Repository] Movimientos obtenidos:", data?.length || 0);
    return data;
  }



}


